// LinkPopover's form state is reset by keying the inner
// LinkPopoverContents on a string derived from `isOpen` + `initialUrl`.
// React unmounts and remounts the child whenever the key changes, so
// the child's `useState(initialUrl)` initialiser runs again with the
// fresh seed — no useEffect re-sync needed.
//
// The key must change in two scenarios:
//   (a) The popover transitions from closed to open (a fresh open
//       always shows the current initialUrl, even if the user typed
//       something else last time and cancelled).
//   (b) The caller swaps initialUrl while the popover is already
//       open — e.g. clicking a different link in the editor without
//       closing the popover first. The new URL becomes the seed.
//
// Both axes go into the key. Joining with a delimiter that can't
// appear in a URL boundary (the URL is on the right of the divider)
// avoids spurious collisions: "true-https://a" and "true-https://a"
// are the same key whether or not the URL contains hyphens.

export function linkPopoverContentsKey(isOpen: boolean, initialUrl: string): string {
    return `${isOpen} ${initialUrl}`
}
